import { FileSyncOutlined } from "@ant-design/icons";
import { Button, Switch } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { onError } from "src/common/onError";
import { MForm } from "src/components/MForm";
import { MfErrorsListView } from "src/components/MForm/components/MfErrorsListView";
import { activateByPath } from "src/components/MForm/formNav/activateByPath";
import { PageLayout } from "src/components/PageLayout";

import { FindFieldByPath } from "./FindFieldByPath";
import * as styles from "./MFormDemoPage.module.less";
import { mFormDemoStore as pageStore } from "./mFormDemoStore";

export const MFormDemoPage: React.FC = observer(() => {
  React.useEffect(() => {
    pageStore.init();
  }, []);
  const goToError = () => {
    const err = Object.values(pageStore.form.errors)[0];
    if (err) {
      setTimeout(() => {
        activateByPath(pageStore.form.root, err.node.dataPath).catch(onError);
      }, 100);
    }
  };
  return (
    <PageLayout title="MForm Demo">
      <div className={styles.tools}>
        <Switch
          title="Запретить/разрешить всю форму"
          value={pageStore.allDisabled}
          onChange={(v) => {
            pageStore.setAllDisabled(v);
          }}
        />
        <Button
          size="small"
          icon={<FileSyncOutlined />}
          title="Сбросить признак изменения"
          disabled={!pageStore.form.root.isChanged}
          onClick={() => pageStore.form.root.setAsUnchanged()}
        />
        <Button
          disabled={Object.keys(pageStore.form.errors).length === 0}
          size="small"
          onClick={goToError}
        >
          Go to Error
        </Button>
        <FindFieldByPath formStore={pageStore.form} />
        <Button
          size="small"
          onClick={() => {
            pageStore.form.setTouched(
              pageStore.form.touched === "all" ? new Set() : "all",
            );
          }}
        >
          Touch
        </Button>
      </div>
      <div className={styles.form}>
        <MForm store={pageStore.form} />
      </div>
      <MfErrorsListView store={pageStore.errListStore} />
    </PageLayout>
  );
});
